// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-link[data-v-1a639cbe]{margin-bottom:12px;font-size:12px!important}.col-links[data-v-1a639cbe]{display:flex;flex-direction:column}", ""]);
// Exports
module.exports = exports;
